import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/traquadroresummo',
    name: 'traquadroresummo',
    description: 'Quadro Resumo do Transporte',
    component: () => import('@/views/transporte/traquadroresummo/Configuracao.vue'),
    meta: { permissions: [eTipoPermissao.QUADRORESUMONOVO_MENU_1100100799] },
    goesToMenu: true,
  },
];
